import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapModalData } from '../../../../../../user/map-redirect-modal/map-redirect-modal.component';
import { AuthenticationService } from '../../../../../../user/authentication.service';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';
import { NgIf, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { UserAccessService } from '../../../../../../user/access/user-access.service';
import { generateInaccessibleModalData } from './inacessible-features-util';
import { GoogleAnalyticsService } from '../../../../../../user/google-analytics.service';

@Component({
  selector: 'app-feature-tooltip',
  templateUrl: './feature-tooltip.component.html',
  styleUrls: ['./feature-tooltip.component.scss'],
  imports: [NgIf, MatTooltip, RouterLink, NgStyle],
})
export class FeatureTooltipComponent implements OnInit {
  @Input() tooltipText!: string;
  @Input() tooltipRouterLink!: string | null;
  @Input() featureName!: string | undefined;
  @Input() featureConst!: string;
  @Input() headerText!: string | undefined;
  @Input() fillColor: string = '#ccc';
  @Input() strokeColor: string = '#A3A3A3';
  @Input() opacity: number = 0.35;
  @Input() clickable: boolean = true;
  @Input() tooltipPosition = 'above' as TooltipPosition;
  @Input() isFeatureInaccessibleType: boolean = false;

  @Output() openTooltipModal = new EventEmitter<MapModalData>();

  public hovered: boolean = false;

  tooltipModalData!: MapModalData;

  constructor(
    public authService: AuthenticationService,
    private accessService: UserAccessService,
    private gaService: GoogleAnalyticsService
  ) {}

  ngOnInit(): void {
    if (this.tooltipText && this.headerText) {
      this.generateDefaultModalData();
    }
  }

  public handleTooltipClick(event: Event): void {
    if (this.tooltipRouterLink) {
      return; // Allow routerLink to do its job
    }

    event.stopPropagation();

    if (this.isFeatureInaccessibleType) {
      if (this.accessService.getIsUnauthorized()) {
        this.gaService.logLockedParamClickGuest();
      } else {
        this.gaService.logLockedParamClickRegistered();
      }
      // If the feature is locked, generate specific modal data for upselling
      this.openTooltipModal.emit(this.getInaccessibleModalData());
    } else {
      // If the feature is accessible, show the default info modal
      if (!this.tooltipModalData) this.generateDefaultModalData();
      this.openTooltipModal.emit(this.tooltipModalData);
    }
  }

  private generateDefaultModalData(): void {
    const parts = this.tooltipText.split('Source:');
    const mainText = parts[0].trim();
    const source = 'Source: ' + parts.slice(1).join('Source: ').trim();

    this.tooltipModalData = {
      headerText: this.featureName,
      subHeaderText: mainText,
      mainText: source,
      disableClose: false,
      hasBackdrop: true,
      disclaimerText:
        'Data and related materials represent an estimation produced from the data provided by a third party. These data are not guaranteed to be accurate, up to date or complete, and are provided "as is". Map AI makes no representations or warranties expressed or implied, with respect to the methods, algorithms, software, data or the related materials, including by way of example and not limitation, the implied warranties of merchantability and fitness for a particular purpose.',
    };
  }

  private getInaccessibleModalData(): MapModalData {
    const featureDisplayName = this.featureName || 'This';
    const isUnauthorized = this.accessService.getIsUnauthorized();

    return generateInaccessibleModalData(
      featureDisplayName,
      isUnauthorized,
      this.featureConst,
    );
  }
}
